// This file was auto-generated by Fern from our API Definition.
export const SimpleTraceKind = {
    Adhoc: "adhoc",
    Eval: "eval",
    Play: "play",
};
